<script>
export default {
  props: {
    value: {
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isNull: {
      type: Boolean,
      default: false,
    },
    isNullLabel: {
      type: String,
      default: '<не указано>',
    },
    isNullValue: {
      default: 0,
    },
  },
};
</script>
<template>
  <div class="select select-tree">
    <el-select
      :clearable="clearable"
      :disabled="disabled"
      :multiple="multiple"
      :filterable="filterable"
      :value="value"
      :collapse-tags="true"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      popper-class="select-tree-dropdown"
    >
      <el-option
        v-if="isNull"
        :label="isNullLabel"
        :value="isNullValue"
      ></el-option>
      <template v-for="item in options.filter(i => !i.ParentId)">
        <el-option
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
        <el-option-group
          :key="`group-${item.value}`"
          v-if="options.filter(i => i.ParentId === item.Id).length"
          class="select-tree__child-1"
        >
          <template v-for="child in options.filter(i => i.ParentId === item.Id)">
            <el-option
              :key="child.value"
              :label="child.label"
              :value="child.value"
              :class="{'selected': value===item.value}"
            />
            <el-option-group
              :key="`group-${child.value}`"
              v-if="options.filter(i => i.ParentId === child.Id).length"
              class="select-tree__child-2"
            >
              <el-option
                v-for="child2 in options.filter(i => i.ParentId === child.Id)"
                :key="child2.value"
                :label="child2.label"
                :value="child2.value"
                :class="{'selected': value===item.value || value===child.value}"
              />
            </el-option-group>
          </template>
        </el-option-group>
      </template>
    </el-select>
  </div>
</template>
<style lang="scss">
  .select-tree{
    .el-select {
      width: 100%;
    }
    .el-select .el-tag {
      max-width: 138px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &-dropdown{
      .el-select-group__title {
        display: none;
      }
      .el-select-group__wrap{
        padding-bottom: 0;
        &::after{
          content: none;
        }
      }
      .el-select-dropdown__item{
        padding-left: 16px;
      }
      .el-select-dropdown__item.selected, .el-select-dropdown__item.selected + ul {
        background-color: rgba(109, 178, 52, 0.3) !important;
        &:hover {
          background-color: rgba(109, 178, 52, 0.3) !important;
        }
        .el-select-dropdown__item:hover {
          background-color: rgba(109, 178, 52, 0.3) !important;
        }
      }
    }
    &__child-1{
      .el-select-dropdown__item{
        padding-left: 32px;
      }
    }
    &__child-2{
      .el-select-dropdown__item{
        padding-left: 48px;
      }
    }
  }
</style>
